module.exports = __webpack_public_path__ + "img/F75701CC.a20fca00.png";